'use client';

import { servicesConfig } from '@/features/services/services.config';
import { useT } from 'next-i18next/client';
import type { FC } from 'react';

export const HeroBlock: FC = () => {
  const { t } = useT(servicesConfig.i18nNamespaces);

  return (
    <div className="bg-[#0A0A0A] relative min-h-[50vh] flex flex-col justify-end">
      <div className="container pb-24 relative">
        <p className="text-xs font-medium tracking-widest uppercase text-[#F24E1E] mb-6">
          {t('services:hero.label')}
        </p>
        <h1 className="text-[clamp(40px,6vw,72px)] font-medium tracking-[-0.025em] leading-[1] text-white max-w-3xl">
          {t('services:hero.title')}
        </h1>
        <p className="mt-6 text-base text-white/60 max-w-md leading-6">
          {t('services:hero.description')}
        </p>
      </div>
    </div>
  );
};
